import { Icon, Icons } from "../../atoms/icon";
import * as styles from "./styles.css";
import * as M from "@discovery/prelude/lib/data/maybe";
import { Typography, Tags, HeaderVariants } from "../../atoms/typography";
import Strings from "../../../utils/hardcoded.json";
export const Toast = ({ toastMsg, successFlag, onClick, isButton, }) => {
    const buttonText = successFlag ? Strings.DONE : Strings.OK;
    return (React.createElement("div", { className: styles.wrapper },
        React.createElement("div", { className: successFlag ? styles.sucessWrapper : styles.failureWrapper },
            React.createElement("div", { className: styles.iconContainer },
                React.createElement(Icon, { type: successFlag ? Icons.Success : Icons.Error, className: styles.iconStyle, color: "white" })),
            React.createElement(Typography, { classNameM: M.of(styles.message), variant: HeaderVariants.headingSix, tag: Tags.h5 },
                React.createElement(React.Fragment, null, toastMsg))),
        isButton ? (React.createElement("div", { onClick: onClick, className: styles.button }, buttonText)) : null));
};

